import React from 'react';
import {FormattedMessage} from 'react-intl';
import { currentLang } from '../components/components/utils';

/** 
 * Explanation of why the language link reloads the page with a query parameter instead of a more
 * "React" like approach of just refreshing the labels of the components:
 * 
 * The WET plugin and the JQuery DataTables plugin (ran by WET) both create elements on the DOM
 * that contain translated language labels.  These newly created elements aren't recognized by React
 * so they don't get translated when React switches the language.  Since these plugins are designed to
 * run once when the page loads, the easiest and most reliable way to ensure that the correct language
 * is being displayed is to reload the page.
 */
function LanguageSelection(props) {
	function getRedirectPath() {
		let pathArr = window.location.pathname?.split('/') ?? "";
		let redirectPath = window.location.pathname
		if (pathArr.length === 2 && (pathArr[1] === "" || pathArr[1] === "index.html")) {	// usually "/index.html[?querystring]"
			redirectPath = "/callback"
		}

		let langValue = "en_CA";
		if (currentLang() === "en") {
			langValue = "fr_CA";
		}
		let urlParams = new URLSearchParams(document.location.search);
		urlParams.set("lang", langValue);

		redirectPath += "?" + urlParams.toString();

		return redirectPath;
	}

	function displayWarning() {
		let languageSwitchActiveKey = localStorage.getItem("languageSwitchActiveKey");

		let formKeys = ["SecureEFiling", "Account_Edit", "SuccessPage"];
		if (formKeys.includes(languageSwitchActiveKey)) {
			let warningMsg = 'Warning, any data entered will be lost.\n\nAre you sure you want to continue?';
			if (document.documentElement.lang === 'fr') {
				warningMsg = 'Attention, toutes les données saisies seront perdues.\n\nEs-tu sûr de vouloir continuer?';
			}
			return window.confirm(warningMsg);
		}
		return true;
	}
	return (
		<>
		  <section id="wb-lng" className="text-right">
		    <h2 className="wb-inv"><FormattedMessage id="wet.languageSelection" /></h2>
		    <ul className="list-inline margin-bottom-none">
		      <li>
		        <a id="langSwitchToggle" lang={currentLang() === "en" ? "fr" : "en"} href={getRedirectPath()} onClick={()=>displayWarning()}>
		          <FormattedMessage id="wet.alternateLanguage" />
		        </a>
		      </li>
		    </ul>
		  </section>
		</>
	);
}

export default LanguageSelection;